<template>
  <field-block title="New Content" v-if="feed.length">
    <div
      class="blog-post mb-3"
      v-for="(link, idx) in feed"
      :key="idx"
      @click="openLink(link.link)"
    >
      <div class="blog-post__image" v-if="link.enclosures">
        <img v-lazy="getImage(link.enclosures)" alt="" />
      </div>
      <div class="blog-post__description">
        <div class="blog-post__title">
          {{ link.title }}
        </div>
        <div class="blog-post__content">
          {{ link.description }}
        </div>
      </div>
    </div>

    <v-btn
      href="https://conveyour.com/blog"
      target="_blank"
      text
      small
      color="appMain"
    >
      Read More
    </v-btn>
  </field-block>
</template>

<script>
import { parse } from 'rss-to-json';

export default {
  name: 'HomeUpdates',
  data() {
    return {
      links: [
        {
          link: '#',
          text: 'Title',
        },
        {
          link: '#',
          text: 'Title',
        },
        {
          link: '#',
          text: 'Title',
        },
      ],
      feed: [],
    };
  },
  methods: {
    async checkRSSFeed() {
      const CYFEED = 'https://conveyour.com/blog/rss.xml';
      const rss = await parse(CYFEED);
      if (rss?.items) {
        this.feed = (rss?.items || []).slice(0, 3);
      }
    },
    openLink(url) {
      window.open(url, '_blank');
    },
    getImage(arr) {
      if (!Array.isArray(arr) || !arr.length || !arr[0]?.url) return;
      return arr[0].url + '/m/0x600';
    },
  },
  created() {
    this.checkRSSFeed();
  },
};
</script>

<style lang="less">
.blog-post {
  display: flex;
  cursor: pointer !important;
  padding: 12px;
  max-width: 100%;
  background-color: var(--v-light-base);
  box-shadow: @base-shadow;
  border-radius: @base-radius;

  &__image {
    width: 44%;
    min-width: 44%;
    height: 140px;
    border-radius: @base-radius;

    img {
      object-fit: cover;
      height: auto;
      max-height: 100%;
      width: 100%;
      border-radius: @base-radius;
      border: 1px solid var(--v-darkGray-base);
      background: var(--v-lightGray-base);
    }
  }

  &__description {
    padding-left: 16px;
  }

  &__title {
    font-size: @font-size-medium;
    color: var(--v-appMain-base);
    font-weight: 600;
    padding-right: 18px;
    margin-bottom: 8px;
  }

  &__content {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    font-size: 14px;
    line-height: 1.5;
    max-height: 80px;
    margin-bottom: 4px;
    font-weight: 500;
  }

  &:hover {
    background-color: var(--v-lightGray-base) !important;
  }
}

@media (max-width: 600px) {
  .blog-post {
    flex-direction: column;

    &__image {
      width: 100%;
      flex: 1;
      margin-bottom: 16px;
    }
  }
}
</style>
